<p-toast position="top-right"></p-toast>

<p-dialog
	[(visible)]="visible"
	(visibleChange)="visibleChange.emit($event)"
	(onHide)="onHide()"
	[modal]="true"
	[closable]="true"
	[draggable]="false"
	[resizable]="false"
	[header]="'Complementos de pago' + (invoice?.folioFiscal ? ' — ' + invoice.folioFiscal : '')"
	[style]="{ width: '720px' }"
	[breakpoints]="{ '960px': '95vw' }">

	<ng-template pTemplate="content">
		<div class="rf-complements">
			<p class="modal-subtitle">Complementos de pago (REP) ligados a esta factura <strong>PPD</strong>. Súbelos para marcarla como <strong>Recibido</strong>.</p>

			<!-- Lista de complementos ligados -->
			<div *ngIf="loading" class="text-color-secondary text-center p-3">Cargando…</div>
			<div *ngIf="!loading && complements.length === 0" class="empty-box">
				<i class="fa-solid fa-receipt"></i>
				<span>Aún no hay complementos de pago ligados a esta factura.</span>
			</div>

			<div class="comp-list" *ngIf="!loading && complements.length">
				<div class="comp-item" *ngFor="let c of complements" [class.comp-item--invalidated]="isInvalidated(c)">
					<div class="comp-head">
						<span class="comp-uid">
							<i class="fa-solid fa-receipt"></i> {{ c.uid }}
							<p-tag *ngIf="isInvalidated(c)" value="Invalidado" severity="danger" styleClass="ml-2"></p-tag>
						</span>
						<span class="comp-actions">
							<button pButton type="button" icon="pi pi-file-pdf" class="p-button-text p-button-sm p-button-danger" pTooltip="PDF" *ngIf="c.pdfUrl" (click)="downloadFile(c._id, 'pdf')"></button>
							<button pButton type="button" icon="pi pi-file" class="p-button-text p-button-sm" pTooltip="XML" *ngIf="c.xmlUrl" (click)="downloadFile(c._id, 'xml')"></button>
						</span>
					</div>
					<div class="comp-docs">
						<div class="comp-doc" *ngFor="let d of relatedForInvoice(c)">
							<span *ngIf="d.paymentDate">Fecha de pago: {{ d.paymentDate | date: 'dd/MM/yyyy' }}</span>
							<span *ngIf="d.amountPaid != null">· Monto: {{ d.amountPaid | currency }}</span>
							<span *ngIf="d.parcialidad != null">· Parcialidad {{ d.parcialidad }}</span>
						</div>
					</div>
					<!-- REP invalidado: el pago que documentaba se canceló. Se conserva como evidencia; debe cancelarse ante el SAT. -->
					<div class="comp-invalidated" *ngIf="isInvalidated(c)">
						<i class="fa-solid fa-triangle-exclamation"></i>
						<div>
							<div>Complemento <strong>invalidado</strong> — el pago que documentaba fue cancelado. <strong>Debe cancelarse ante el SAT.</strong></div>
							<div class="comp-invalidated-meta">
								<span *ngIf="c.invalidatedAt">{{ c.invalidatedAt | date: 'dd/MM/yyyy HH:mm' }}</span>
								<span *ngIf="userName(c.invalidatedBy)"> · por {{ userName(c.invalidatedBy) }}</span>
								<span *ngIf="c.invalidatedReason"> · {{ c.invalidatedReason }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Zona de carga de nuevos REP -->
			<div class="upload-block" *appIfHasPermission="['invoices','create']">
				<label class="upload-label">Cargar complemento de pago (PDF y/o XML del REP)</label>
				<div class="dropzone" [class.dragging]="isDragging" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
					<input type="file" id="compFiles" multiple accept=".pdf,.xml" (change)="onFilesSelected($event)" hidden />
					<label for="compFiles" class="dropzone-label">
						<i class="fa-solid fa-cloud-arrow-up"></i>
						<span>Arrastra aquí los archivos o haz clic para seleccionarlos</span>
					</label>
					<div class="selected-count" *ngIf="selectedFiles.length">{{ selectedFiles.length }} archivo(s) seleccionado(s)</div>
				</div>
			</div>
		</div>
	</ng-template>

	<ng-template pTemplate="footer">
		<button pButton type="button" label="Cerrar" class="p-button-text" (click)="close()" [disabled]="uploading"></button>
		<button pButton type="button" label="Subir complemento" icon="fa-solid fa-cloud-arrow-up" *appIfHasPermission="['invoices','create']" (click)="upload()" [disabled]="uploading || !selectedFiles.length" [loading]="uploading"></button>
	</ng-template>
</p-dialog>
